// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_GROUP_POSTS = ["%(counter)s p\u0159\u00edsp\u011bvek", "%(counter)s p\u0159\u00edsp\u011bvky", "%(counter)s p\u0159\u00edsp\u011bvk\u016f"];
export const SHOW_ALL_GROUPS = "Dal\u0161\u00ed skupiny";
